export default __webpack_public_path__ + "static/cHwRNUTw-72c70a8867c3f848bc6d8e8351d904ef.svg";